import { ButtonTheme } from './button.enum';

export interface ButtonConfig {
  theme?: ButtonTheme;
}
